import { apiTypes }                               from 'shared/consts/handbooksApiTypes';
import { ActionType, ConditionType, TriggerType } from 'views/pages/Handbooks/SpreadSheetHandbook/components/SingleTable';

const config = {
  canCreate:    false,
  canDelete:    false,
  hideExport:   true,
  table:       'temp_sensor_types',
  title:       'Типы датчиков температуры',
  apiType:     apiTypes.REPORT_API,
  elemsOnPage: 100,
  fields:      [
    {
      name:  'id',
      title: 'Номер',
      index: true,
      type:  'number',
      width: '120px',
    },
    {
      name:     'sensor_name',
      title:    'Наименование',
      type:     'text',
      required: false,
    },
    {
      name:     'sensor_type',
      title:    'Тип установки',
      type:     'list',
      required: false,
      values:   [
        { key: null, value: '' },
        { key: 'Кабина водителя', value: 'Кабина водителя' },
        { key: 'Салон', value: 'Салон' },
        { key: 'Наружный', value: 'Наружный' },
      ],
    },
    {
      name:     'eqn',
      title:    'EQN',
      type:     'list',
      required: true,
      values:   [
        { key: 71, value: 71 },
        { key: 72, value: 72 },
        { key: 73, value: 73 },
        { key: 74, value: 74 },
        { key: 75, value: 75 },
        { key: 76, value: 76 },
        { key: 77, value: 77 },
        { key: 78, value: 78 },
      ],
    },
  ],
  newTemplate: {
    id:                null,
    sensor_name:       '',
    sensor_type:       '',
    eqn:               null,
  },
  defaultSort: {
    field:     'id',
    direction: 'desc',
  },
  export:      {
    fields: [
      {
        name:  'id',
        title: 'Номер',
      },
      {
        name:  'sensor_name',
        title: 'Наименование',
      },
      {
        name:  'sensor_type',
        title: 'Тип установки',
      },
      {
        name:  'eqn',
        title: 'EQN',
      },
    ],
  },
  rules: [
    {
      trigger: TriggerType.Update,
      conditions: [
        {
          type: ConditionType.EmptyField,
          fields: ["sensor_name", "sensor_type"],
        }
      ],
      action: {
        type: ActionType.ShowConfirm,
        payload: {
          title: "",
          message: "",
          onConfirm: "",
          onCancel: "",
        },
      },
    },
  ],
};

export default config;
